module.exports = __webpack_public_path__ + "static/media/shadows.d0643f34.jpg";